import React from "react";
import "semantic-ui-css/semantic.min.css";
import styled from "styled-components";
import { Button } from "semantic-ui-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";




const CarouselWrapper = styled.div`
  margin-top: 40px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
    gap: 10px;
`;
const SlideItem = styled.div`
  padding: 0 15px; // Adjust this value for spacing
  display: flex;
  justify-content: center;
   align-items: center;
   
`;

const Logo = styled.img`
  width: 100%;
  height: 120px;
  object-fit: contain;
  margin: auto;
`;

const Caption = styled.p`
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333;
`;

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,             
  autoplaySpeed: 2000,     
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};








const HeaderLogo = styled.img`
  height: 120%;
  width: 120%;
  margin-left: -40px;
  margin-right: auto;
  display: block;
   object-fit: contain;

`;

const LogoWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;

`;

interface LogoProps {
  width?: string;
  height?: string;
}

const FlexibleLogo = styled.img<LogoProps>`
  width: ${({ width }) => width || "100px"};
  height: ${({ height }) => height || "100px"};
  object-fit: contain;
`;

export const LandingPage = ({ setShowLandingPage }: any) => {
  return (
    <div className="landing">
      <div className="landing-inner">
        <HeaderLogo src="/assets/images/newserve.png" />

        <h3 style={{ margin: "-30px 0px 30px 0px", color: "white", fontSize: "17px" }}>
          Connecting our Defence and Veteran Community<br />
          To Services and Support
        </h3>

        <Button className="landingButton" onClick={() => setShowLandingPage(false)}>
          Enter
        </Button>
        
        
        <CarouselWrapper>

  <Slider {...sliderSettings}>
      <SlideItem>
<Logo src="/assets/images/Holan Group.png" alt="Sponsor 1" title="At Holan Group, we are more than just consultants – we are partners in progress. We aim to help you achieve more today while building a better tomorrow. 
  We collaborate with businesses across diverse industries through strategic project management and consulting to drive innovation, optimise performance and deliver lasting impact.
  What sets us apart is our community-first mindset. Every project we undertake is guided by a commitment to excellence, sustainability, and meaningful change. We don’t just advise – we ensure our clients and the communities we serve thrive in an ever-evolving landscape."/>
</SlideItem>
  <SlideItem>
    <Logo src="/assets/images/KSC-Logo-Reversed.png" alt="Sponsor 2" title="We’re excited to welcome KSC Claims to the Servulink Digital Hub. Established by Australian veterans,KSC Claims is a fully digital advocacy service designed to make navigating the Department of Veterans’ Affairs (DVA) claims process straightforward, supportive, and stress-free.
  Since 2020, the team has assisted over 3,000 veterans in securing the entitlements they deserve, providing a comprehensive suite of services including initial liability and permanent impairment claims, appeals and VRB reviews, household services support, guidance across MRCA, DRCA, and VEA schemes, and ongoing post-claim assistance. 
  Offering a free 30-minute consultation and a commitment to respond to veterans within 12 hours, seven days a week, KSC Claims delivers practical, veteran-focused advocacy every step of the way." />
</SlideItem>
  <SlideItem>
    <Logo src="/assets/images/KM_ICON.png" alt="Sponsor 3" title="We are thrilled to share that Kinetic Medicine has joined Servulink Digital Hub. Their team of Exercise Physiologists deliver programs focusing on movement as medicine to improve wellbeing and physical health. Kinetic programs are offered across regional Australia to our veterans.
Find a Kinetic Medicine service near you by simply searching Kinetic Medicine and the hub will geolocate to your nearest Kinetic location"/>
</SlideItem>
  <SlideItem>
    <Logo src="/assets/images/AOLbigger.png" alt="Sponsor 4" title="Advocates Online provide professional representation and support for veterans through service, transition, and life after defence.

Through their individual tailored approach, which includes education and knowledge sharing, veterans are empowered to decide what is best for them and their family’s future.

Whether it be medical separation, DVA claims or invalidity / TPD pensions, Advocates Online are committed to serve. They are the Custodians of Veteran Advocacy, dedicated to working with all those who equally commit to acknowledging the unique nature of military service and the contribution of veterans and their families." />
</SlideItem>
  <SlideItem>
   <Logo src="/assets/images/MjConsulting.png" alt="Sponsor 4" title="Accountants" />
</SlideItem>

  </Slider>
  
</CarouselWrapper>

        
        

      <h2 style={{ margin: "0px 0px 0px 0px", color: "whitesmoke", fontSize: "17px" }}>
          Recognising our major sponsors
        </h2>

        <h3 style={{ margin: "130px 0px 0px 0px", color: "white", fontSize: "15px" }}>
          ** Servulink Digital Hub is not affiliated with or acting on behalf of any government organization or entity. **<br />
        </h3>
      </div>
    </div>
  );
};